import type { ItemRow } from './itemsTable.types'

interface BrandCellProps {
  row: ItemRow
  /** Бренд есть в справочнике «Бренды» — ячейка подсвечивается зелёным. */
  known: boolean
  cellClass: string
  onChange: (value: string) => void
  onRegister: (el: HTMLInputElement | null) => void
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void
}

const sameBrand = (a: string, b: string) => a.trim().toLowerCase() === b.trim().toLowerCase()

/** Выбор бренда показываем, пока партномер тот же, для которого парсер заменил бренд. */
export function activeBrandChoice(row: ItemRow): { catalog: string; input: string } | null {
  const choice = row.brandChoice
  if (!choice || choice.forPartNumber !== row.partNumber.trim()) return null
  return choice
}

// Поле «Бренд» в таблице позиций. Если парсер заменил указанный менеджером бренд
// каталожным, под полем — переключатель из двух вариантов: по умолчанию стоит
// каталожный, указанный в заявке возвращается одним кликом.
export function BrandCell({
  row,
  known,
  cellClass,
  onChange,
  onRegister,
  onKeyDown,
}: BrandCellProps) {
  const choice = activeBrandChoice(row)
  const options = choice
    ? [
        { key: 'catalog', label: 'Каталог', value: choice.catalog, hint: 'Бренд из каталога' },
        { key: 'input', label: 'Указан', value: choice.input, hint: 'Бренд, указанный в заявке' },
      ]
    : []

  return (
    <>
      <input
        ref={onRegister}
        value={row.brand}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder="ST, TI..."
        className={`${cellClass} ${known ? 'bg-green-50 text-green-700 font-medium' : ''}`}
      />
      {options.length > 0 && (
        <div className="flex flex-wrap gap-1 px-1 pb-1" data-testid="brand-choice">
          {options.map((o) => {
            const active = sameBrand(row.brand, o.value)
            return (
              <button
                key={o.key}
                type="button"
                title={`${o.hint}: ${o.value}`}
                aria-pressed={active}
                onClick={() => onChange(o.value)}
                className={`max-w-full truncate rounded px-1.5 py-0.5 text-[10px] leading-tight border ${
                  active
                    ? 'border-brand-600 bg-brand-600 text-white'
                    : 'border-gray-300 bg-white text-gray-600 hover:border-brand-500 hover:text-brand-700'
                }`}
              >
                {o.label}: {o.value}
              </button>
            )
          })}
        </div>
      )}
    </>
  )
}
